import icon from "../../assets/uplink-speed.svg";
import type { Property } from "../../types";

export const uplinkSpeed: Property = {
  id: "uplinkSpeed",
  title: "uplinkSpeed.title",
  icon,
};
